'use strict';

var _ = require('lodash');

var React = require('react');
var ComponentFactory = require('../../infrastructure/ComponentFactory');

var ImportTypes = require('../../constants/ImportTypes');

var UserStore = require('../../stores/UserStore');
var ImportProgressStore = require('../../stores/ImportProgressStore');
var ImportHistoryStore = require('../../stores/ImportHistoryStore');

var ImportActionsCreator = require('../../actions/ImportActionsCreator');
var UserInfoActionsCreator = require('../../actions/UserInfoActionsCreator');
var ComponentActionsCreator = require('../../actions/ComponentActionsCreator');

var TwitterActionsCreator = require('../../actions/TwitterActionsCreator');

var ContentStore = require('../../stores/ContentStore');
var ContentTypes = require('../../constants/ContentTypes');

/** @module TwitterImport
 * @requires lodash
 * @requires react
 * @requires ComponentFactory
 * @requires ImportTypes
 * @requires UserStore
 * @requires ImportProgressStore
 * @requires ImportHistoryStore
 * @requires ImportActionsCreator
 * @requires UserInfoActionsCreator
 * @requires ComponentActionsCreator
 * @requires TwitterActionsCreator
 * @requires ContentStore
 * @requires ContentTypes
 */
var TwitterImport = ComponentFactory.Create(UserStore, ImportProgressStore, ImportHistoryStore, ContentStore, {
	displayName: "TwitterImport",
	/**
	 * @method getState
	 */
	getState: function() {
		var state = {
			returnTo: this.route().path,
			isUserAuthenticated: UserStore.getMetaState().filled && !!UserStore.getState('twitter_connected'),
			importProgress: ImportProgressStore.getState(ImportTypes.TWITTER),
			ready: UserStore.getMetaState().filled && ImportProgressStore.getMetaState(ImportTypes.TWITTER).filled,

			importedFileCount: _(ContentStore.getState())
				.values()
				.flatten()
				.filter((x) => _.isEqual(x.import_type, ImportTypes.TWITTER))
				.filter((x) => _.isEqual(x.content_type, ContentTypes.IMAGE))
				.size()
		};
		state.loading = !state.ready || state.importProgress.progress;
		return state;
	},

	/**
	 * @method componentDidUpdate
	 */
	componentDidUpdate: function() {
		UserInfoActionsCreator.loadUserInfo();
		ComponentActionsCreator.loadImportHistory(ImportTypes.TWITTER);

		this._importAutoStart();
	},

	/**
	 * @method _startImport
	 */
	_startImport: function() {
		if(this.state.isUserAuthenticated && !this.state.importProgress.progress) {
			ImportActionsCreator.startImport(ImportTypes.TWITTER);
		}
	},

	/**
	 * @method _importAutoStart
	 */
	_importAutoStart: function() {
		if (this.state.ready && !_(this.state.importProgress).values().compact().some()) {
			this._startImport();
		}
	},

	/**
	 * @method _onClick
	 */
	_onClick: function() {
		if (!this.state.ready) {
			return;
		}
		if(this.state.isUserAuthenticated) {
			this._startImport();
		} else {
			TwitterActionsCreator.requestTwitterAuthorizationUrl(this.state.returnTo);
		}
	},

	/**
	 * @method _onMouseEnter
	 */
	_onMouseEnter: function() {
		this.setState({mouseOver: true});
	},

	/**
	 * @method _onMouseLeave
	 */
	_onMouseLeave: function() {
		this.setState({mouseOver: false});
	},

	/**
	 * @method render
	 */
	render: function () {
		var css = {
			'twitter': true,
			'active': this.state.isUserAuthenticated
		};

		var iconClassName = "mdi mdi-twitter" + (this.state.loading ? " pulse" : "");

		var wrapperClassName;
		var output;

		if(_.get(this.props, "button", false)){
			output = (<div className="import-header-column import-header-column-button bg-overlay twitter"
				onClick={this._onClick}>
				<div>
					<div className="show-for-large-up import-label" >
						<p >{this.props.title}</p>
						<h3 >{this.props.tagline}</h3>
					</div>
					<div className="import-icon-holder" >
						<div className={"circle-icon " + this.css(css)}
							onClick={this._onClick}
							title="Import Twitter">
							<i className={iconClassName}></i>
						</div>
						<div className="import-icon-bubble-holder" >
							<div className={"bubbleNumber " + this.css(css)} >
								<div className="bubbleLeft"></div>
								<div className="bubbleRight"></div>
								<div className="bubbleText">
									<p>{this.state.importedFileCount}</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>);
		} else {
			wrapperClassName = 'media-source';
			output = (<div>
				<div className={"circle-icon " + this.css(css)} onClick={this._onClick} title="Import Twitter">
					<i className={iconClassName}></i>
				</div>
				<div className="import-icon-bubble-holder" >
					<div className={"bubbleNumber " + this.css(css)} >
						<div className="bubbleLeft"></div>
						<div className="bubbleRight"></div>
						<div className="bubbleText">
							<p>{this.state.importedFileCount}</p>
						</div>
					</div>
				</div>
			</div>);
		}
		return (<div className={wrapperClassName}>{output}</div>);
	}
});

module.exports = TwitterImport;
